// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__Qaq-k","tab":"Tabs_tab__qam9r"};